export default {
  current_status: {
    not_started: {
      key: 'not_started',
      label: 'Not started',
    },
    completed: {
      key: 'completed',
      label: 'Completed',
    },
    redeemed: {
      key: 'redeemed',
      label: 'Redeemed',
    },
  },
};
